<template>
  <div class="w-full">
    
    <b-sidebar
      type="is-light"
      :fullheight="fullheight"
      :fullwidth=false
      :overlay="overlay"
      :right="right"
      v-model="open"
    >
      <div class="p-1">
        <strong>Kursinhalt</strong>
        
        <p>{{ course.name }}</p>
        <br>
        <b-collapse
            class="card"
            animation="slide"
            v-for="(section, index) of course.sections"
            :key="index"
            :open="isOpen == index"
            @open="isOpen = index"
            :aria-id="'contentIdForA11y5-' + index">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    :aria-controls="'contentIdForA11y5-' + index"
                    :aria-expanded="props.open"
                >
                    <p
                    :class="{ activeSection: isActive }">
                    {{ section.name }}
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>
            <div class="card-content">
                <div class="content">
                  <router-link
                      v-for="(mod, mod_index) in section.modules"
                      :key="'mod_div' + mod.id + mod_index"
                      :to='{ path: "/courses/" + course.id + "/" + index + "/" + mod_index , params: { id: course.id, mod_id: mod.id } }'
                      @click.native="open = false"
                      >
                      {{ mod.name }}
                    </router-link> 
                </div>
            </div>
        </b-collapse>

      </div>
    </b-sidebar>
    <div class="w-full px-6">
      <div class="lg:flex flex-wrap">
        <div v-if="
          this.protect && !isInstructorsCourse || 
          course.isDraft && !isInstructorsCourse || 
          course.course_category.name === 'Tutorial' && user.role.name < 2 || 
          course.isProtected && user.role.name == 0 ||
          user.rolle != this.course.courseProfession && !superAdmin" 
        ></div>
        <!-- class="py-10 lg:w-2/3 w-full md:pr-6 sm:border-r border-gray-300" -->
        <div
          class="py-10 lg:w-3/3 w-full md:pr-6 "
          v-else-if="!this.protect && course || superAdmin"
        >
          <div class="flex justify-between items-center">
            <router-link :to="{ path: '/courses/' + course.id, params: { id: course.id } }">
              <div class="flex items-center">
                <div
                  class="mr-3 w-6 h-6 rounded-full text-gray-500 border border-gray-500 flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-chevron-left"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <polyline points="15 6 9 12 15 18" />
                  </svg>
                </div>
                <h4 class="text-xl text-gray-900">Zurück zum Kurs {{ course.name }}</h4>
               
              </div>
            </router-link>
           <!-- <b-button @click="open = true">Show</b-button> -->
           <b-button 
             class="font-bold rounded-full" 
             @click="open = true"
             type="is-primary is-light"
             >Inhaltesverzeichnis</b-button>
          </div>

<!-- Auswahl der Module über eigenen Button -->
<!-- @click="isActive = !isActive" -->
            <div 
              class="py-2 w-full px-3 "
            >
            <!-- Contentmodule im Sidepanel anzeigen -->
<!-- Border at the end of section card border-b-4 border-gray-800 -->
            <div 
              v-for="(section, section_index) in course.sections"
                :key="section.id"
              :class="{ activeSection: isActive }"
            >
            <div v-if="sectionRouteId == section_index" >      
            <!-- <hr class="my-8 border-t border-gray-300" /> -->
            <div class="card py-5 w-full my-4 px-3 flex items-center">
              <h5 class="text-gray-900 font-medium ml-3">Inhalt Kapitel {{ section_index + 1 }}</h5>
              <br> 
              <p>{{ section.name }}</p>
              <!-- <div v-if="course.instructor.email == user.email" class="tile is-child box">
                <p>Kapitel QR-Code</p>
                <b-button size="is-small" @click="createBuildUrl(section.id)">QR Code erzeugen</b-button>
                <img v-bind:src="fullQRUrl" alt="Kein QR-Code vorhanden">
              </div> -->
            </div>

            <div
            v-for="(mod, mod_index) in section.modules"
            :key="'mod_div' + mod.id + mod_index"
            class="py-10 w-full my-8 px-6"
            >
            <div>
             <!-- {{ mod.id }} {{ mod.name }} - {{ sectionRouteId }} = {{ section_index }} - {{ moduleId }}  -->
                <div v-show="mod.id" class="flex mt-6 justify-between items-center">
                  <div class="flex items-center">
                    <h5 class="text-gray-900 font-medium">
                      {{ section_index + 1 }}.{{ mod_index + 1 }}
                    </h5>

                    <!-- <h5 class="text-gray-900 font-medium ml-3">
                      {{ mod.name }} {{ mod.id }}
                    </h5> -->
                    <div>
                    <section>
                        <b-field class="px-2">
                          <b-tooltip position="is-bottom" multilined>
                            <b-tag type="is-info is-light" rounded size="is-small">CC-Lizenz</b-tag>
                            <template v-slot:content>
                                <b>CC-Lizenzen:</b>
                                <div v-if="mod.CC.CC_0 === '0'">CC-0</div>
                                <div v-if="mod.CC.CC_BY === 'BY'">BY</div>
                                <div v-if="mod.CC.CC_NC === 'NC'">NC</div>
                                <div v-if="mod.CC.CC_ND === 'ND'">ND</div>
                                <div v-if="mod.CC.CC_SA === 'SA'">SA</div>
                            </template>
                        </b-tooltip>
                            
                        </b-field>
                    </section>
                  </div>
                  <div v-if="!mod.licence">
                    <section>
                        <b-field>
                          <b-tooltip position="is-bottom" multilined>
                            <b-tag type="is-danger is-light" rounded size="is-small">
                              <font-awesome-icon
                                :icon="lockedIcon"
                                color="blue"
                                class="items-center"
                              />
                              Content Dritter</b-tag>
                            <template v-slot:content>
                                <b>Content Dritter</b>, Leider haben wir keine Freigabe.
                            </template>
                        </b-tooltip>
                            
                        </b-field>
                    </section>
                  </div>
                  </div>
                </div>
               
                <strong>{{ mod.name }}</strong>  
                <p>Beschreibung</p>
                <br>
                <p>{{ mod.description }}</p>
    
                <!-- course.users_permissions_users.some((p) => p.email) -->
                <!-- {{ userInvited }} {{ course.isInvite }} {{ course.users_permissions_users.some((p) => p.email === user.email) }} isInviteCourse: {{ course.isInviteCourse }} noLicence: {{ course.noLicence }} isInstructorsCourse: {{ isInstructorsCourse }}  -->
                <div v-if="!course.isPublic && user.role.name > 0 && !course.isInviteCourse || course.isPublic && user.role.name >= 0 || isInstructorsCourse">
                <div v-if="!course.isInvite && !course.isInviteCourse || isInstructorsCourse || course.users_permissions_users.some((p) => p.email === user.email) || !course.isPublic && user.role.name > 0 || course.isInviteCourse === !course.isInviteCourse">
                  
                  <div >
                    <div>
                <!--   {{course.isPublic}} {{isInstructorsCourse}} -->
                  <!-- {{!course.isPublic}} -->
                <div v-for="media in mod.media" :key="media.id" class="mt-2">
                  <div
                    v-if="media.mime == 'application/pdf'"
                    class="flex items-center"
                  >
                    <!-- <img src="/assets/images/PDF_file_icon.png" /> -->
                    <font-awesome-icon class="red-color" icon="fa-file-pdf" />
                    <a :href="media.url" target="_blank">&nbsp;{{
                      media.name 
                    }}</a>
                  </div>
                  <div class="video" v-if="media.mime == 'video/mp4'">
                    <video controls class="video-width">
                    <source 
                      :src="media.url" 
                      :type="media.mime"/>
                    Sorry, your browser doesn't support embedded videos.
                    </video>
                    <a :href="media.url" target="_blank">Alternativer Link: {{
                      media.name
                    }}</a>
                  </div>
                  <div v-if="media.mime == 'application/zip'">
                    <!-- <font-awesome-icon class="text-xl" :icon="['fa-solid', 'fa-file-zipper']" /> -->
                    <!-- <video :src="'//' + API_URL + media.url"></video> -->
                    <a :href="media.url" target="_blank">&nbsp;{{
                      media.name
                    }}</a>
                  </div>
                  <div v-if="media.mime == 'text/html'">
                    <a :href="media.url" target="_blank"
                      >Die Seite öffnen <font-awesome-icon class="ml-3" :icon="['far', 'fa-file-pdf']" /></a
                    >
                  </div>
                  <div v-if="!media.url">media: {{ media }}</div>
                </div>
                </div>
                <div>
                    <div v-for="(mod, mod_index) in section.modules" :key="'mod_div' + mod.id + mod_index">
                      <div v-if="mod.iFrame_URL">
                        <br>
                        <!-- <h1>Webinar</h1> -->
                        <div class="iframe-container">
                          <iframe :src="mod.iFrame_URL" frameborder="0" allowfullscreen></iframe>
                        </div>
                        <!-- <a :href="mod.iFrame_URL" target="_blank">{{ mod.iFrame_URL }}</a> -->
                        <b-button
                          type="is-link is-light"
                          tag="a"
                          target="_blank"
                          :href="mod.iFrame_URL"
                          icon-left="github-circle"
                          >
                          In einem neuen Fenster öffnen
                        </b-button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
            
              <!-- <b-rate
                :max="5" 
                :readonly="false" 
                @input="success"
                v-model="rate"
                @change="success" 
                custom-text="With Font Awesome"></b-rate> -->
           
        </div>

        </div>
<!-- Komentiere für den Autor und sende eine direkte Nachricht als Email -->
          <!-- <div class="">
            <p class="subtitle">Kommentiere dieses Modul</p>
            <b-field>
                <b-input placeholder="Kommentieren ..."
                    size="is-medium"
                    icon="account">
                </b-input>
            </b-field>
            <button
                  class="focus:outline-none ml-0 md:ml-5 bg-white transition duration-150 ease-in-out hover:bg-gray-100 rounded text-gray-800 px-3 md:px-6 py-2 text-sm border border-gray-800"
                >
                  Kommentar an Autor senden
                </button> 
          </div>  -->
        </div>
  
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-4 is-vertical is-parent">
          <div class="tile is-child box">
            <p class="title">Kategorien</p>
            <div 
              v-for="(section) in course.sections"
                :key="section.id">
            <div
            v-for="(mod, mod_index) in section.modules"
            :key="'mod_category' + mod.name + mod_index"
            class="tag-container"
            >
              <div
                class="container px-2 py-2"
                v-if="mod.module_subcategory"
              >
                <b-field grouped>
                  <div v-for="module_subcategory in mod.module_subcategory" :key="module_subcategory.id" class="control mt-2">             
                    <span>                       
                        <b-tag class="tag-item" rounded size="is-medium">{{ module_subcategory.key.key }}</b-tag>             
                    </span>
                  </div>
                </b-field>
              </div>
            </div>   
          </div>       
        </div>
          <div class="tile is-child box">
            <p class="title">Quicks</p>
            <p>Scan den QR-Code und du wirst sofort zu diesem Modul weitergeleitet.</p>
            <img v-bind:src="fullUrl" alt="Kein QR-Code vorhanden">
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child box">
            <p class="title">Werkzeugkiste</p>
            <b-message type="is-info" has-icon>
              Die Werkzeugkiste benötigt spezielle Berechtigungen und wird momentan noch entwickelt.
           </b-message>
           <!-- <div>
              <textarea v-model="inputText" rows="5" cols="50" placeholder="Paste your text here"></textarea>
              <b-button type="is-primary is-light" @click="summarizeText">Summarize</b-button>
              <div v-if="summary">
                <h2>Summary:</h2>
                <p>{{ summary }}</p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>


           <!-- Instructor Placeholder for Component -->
      <div class="py-16">
            <h4 class="text-gray-900 text-xl font-medium mb-6">Kursleiter</h4>
            <div class="flex items-center justify-between">
              <div class="flex items-center justify-between">
              <div class="box flex items-center">
                <div class="h-8 w-8">
                  <img
                    src="https://tuk-cdn.s3.amazonaws.com/assets/components/avatars/a_4_2.png"
                    alt
                    class="h-full w-full rounded-full overflow-hidden shadow"
                  />
                </div>
                <div class="ml-2">
                  <h5 class="text-xs text-gray-800">{{ course.instructor.firstName }} {{ course.instructor.lastName }}</h5>
                  <p class="text-xs text-gray-800">{{ course.instructor.profession }}</p>
                </div>
              </div>
<!--               <button
                class="focus:outline-none ml-0 md:ml-5 bg-white transition duration-150 ease-in-out hover:bg-gray-100 rounded text-gray-800 px-3 md:px-6 py-2 text-sm border border-gray-800"
              >
                Follow
              </button> -->
              </div>
            </div>
           <!--  <pdf-summarizer></pdf-summarizer> -->
       
            
            <!-- <button @click="generateDescription">Generate Description</button>
              <div v-if="description">
                <h2>Description:</h2>
                <p>{{ description }}</p>
              </div> -->

<!--               <button
                class="focus:outline-none ml-0 md:ml-5 bg-white transition duration-150 ease-in-out hover:bg-gray-100 rounded text-gray-800 px-3 md:px-6 py-2 text-sm border border-gray-800"
              >
                Follow
              </button> -->
            
          </div> 
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>education Brandenburg</strong> {{ currentDate }}
        </p>
      </div>
    </footer>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          The source code is licensed
          <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
          is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue';
import gql from "graphql-tag";

// import { mapState } from "vuex";

// import { OpenAI } from 'openai';

// import ToggleProtectButton from '../components/ToggleProtectButton.vue'

import Buefy from 'buefy';
import { ToastProgrammatic as Toast} from 'buefy';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf, faLock, faUserShield, fas } from '@fortawesome/free-solid-svg-icons';

import { mapState } from "vuex";

// import PdfSummarizer from '@/components/PdfSummarizer.vue'
// import PdfReader from '@/components/PdfReader.vue';
// import { GridLayout, GridItem } from 'vue-grid-layout';

import 'buefy/dist/buefy.css'

library.add(faFilePdf, faLock, faUserShield, fas);

Vue.use(Buefy);

import Sortable from 'sortablejs'

const createSortable = (el, options, vnode) => {
        return Sortable.create(el, {
            ...options,
            onEnd: function (evt) {
                const data = vnode.componentInstance.$data.tags
                const item = data[evt.oldIndex]
                if (evt.newIndex > evt.oldIndex) {
                    for (let i = evt.oldIndex; i < evt.newIndex; i++) {
                        data[i] = data[i + 1]
                    }
                } else {
                    for (let i = evt.oldIndex; i > evt.newIndex; i--) {
                        data[i] = data[i - 1]
                    }
                }
                data[evt.newIndex] = item
                vnode.componentInstance.$emit('input', data)
                vnode.context.$buefy.toast.open(`Moved ${item} from row ${evt.oldIndex + 1} to ${evt.newIndex + 1}`)
            }
        })
    }

    /**
     * We add a new instance of Sortable when the element
     * is bound or updated, and destroy it when it's unbound.
     */
    const sortable = {
        name: 'sortable',
        bind(el, binding, vnode) {
            const container = el.querySelector('.taginput-container')
            container._sortable = createSortable(container, binding.value, vnode)
        },
        update(el, binding, vnode) {
            const container = el.querySelector('.taginput-container')
            container._sortable.destroy()
            container._sortable = createSortable(container, binding.value, vnode)
        },
        unbind(el) {
            const container = el.querySelector('.taginput-container')
            container._sortable.destroy()
        }
    }

    const ModalForm = {
        props: ['email', 'password'],
        template: `
        <div class="modal">
          <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">Modal title</p>
              <button class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
              <!-- Content ... -->
            </section>
            <footer class="modal-card-foot">
              <button class="button is-success">Save changes</button>
              <button class="button">Cancel</button>
            </footer>
          </div>
        </div>
        `
    }

export default {
  components: { 
    // GridLayout,
    // GridItem,
    // PdfSummarizer,
    FontAwesomeIcon,
  },
  name: "HelloWorld",
  directives: { sortable },
  data: function () {
    return {
      sortableOptions: {
          chosenClass: 'is-primary',
          draggable: '.tag'
      },
      tags: [
      ],
      dataToBeWatched: '',
      user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
      course: {},
      active: false,
      isScrollable: true,
      maxHeight: 600,
      searchTerm: '',
      selectedOptions: [],
      isActive: false,
      isActiveHint: true,
      isActiveHintVr: true,
      isActiveHintInvited: true,
      modules: [],
      courseCategories: [],
      moduleCategories: [],
      JsonObjectA: [],
      protect: false,
      skills: [],
      isUsersCourse: null,
      isInstructorsCourse: null,
      superAdmin: false,
      userInvited: false,
      edited: false,
      tab: "Videos",
      userId : '',
      moduleId: '',
      sectionRouteId: '',
      open: false,
      isOpen: false,
      collapses: [
        {
            title: 'Title 1',
            text: 'Text 1'
        },
        {
            title: 'Title 2',
            text: 'Text 2'
        },
        {
            title: 'Title 3',
            text: 'Text 3'
        }
      ],
      isOpenSection: 0,
      danger: false,
      overlay: true,
      fullheight: true,
      fullwidth:true,
      lockedIcon: "fas fa-lock",
      right: true,
      p: "",
      p2: "",
      url: "",
      fullUrl: "",
      fullQRUrl: "",
      API_URL:
        process.env.NODE_ENV == "production"
          ? process.env.VUE_APP_STRAPI_API_URL
          : "localhost:1338",
      FRONTEND_URL:
        process.env.NODE_ENV == "production"
          ? "https://edubb.vercel.app"
          : "http://localhost:1338",
      currentMenu: { icon: 'account-group', text: 'Contentmodule' },
      menus: [
          { icon: 'account-group', text: 'People' },
          { icon: 'shopping-search', text: 'Orders' },
          { icon: 'credit-card-multiple', text: 'Payments' },
          { icon: 'dolly', text: 'Logistics' },
          { icon: 'clock-check', text: 'Jobs' },
          { icon: 'cart-arrow-right', text: 'Cart' },
          { icon: 'settings', text: 'Configuration' }
      ],
      inputText: '',
      summary: '',
      description: '',
      rate: 4.6,
      packs: "fas", // Set the icon pack to "fas" for Font Awesome Solid icons
      icons: {
        empty: ["far", "star"], // Use Font Awesome Regular star icon for empty rating
        full: ["fas", "star"], // Use Font Awesome Solid star icon for full rating
      },
    };
  },
  updated(){
    try{
        this.countlicence()
        this.moduleId = this.$router.history.current.params.moduleId;
        this.sectionRouteId = this.$router.history.current.params.sectionRouteId;
        this.courseId = this.$router.history.current.params.id;
        console.log(this.$route.path)
        console.log("moduleId", this.moduleId)
        console.log("sectionId", this.sectionRouteId)
        console.log("courseId", this.courseId)

        this.buildUrl()

      }catch(e){
        console.log(e)
      }
  },
  // created() {
  //   openai.configure({
  //     apiKey: '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' // Replace with your actual OpenAI API key
  //   });
  // }, 
  methods: {
    success() {
        this.$buefy.toast.open({
            message: 'Thanks for you Rate!',
            type: 'is-success'
        })
    },
    // async summarizeText() {
    //  // const text = 'Your text to summarize goes here';
    //  let apiKey = process.env.VUE_APP_OPENAI_API_KEY

    //   const openai = new OpenAI({
    //     apiKey: apiKey,
    //     dangerouslyAllowBrowser: true
    //   });

    //   console.log("inputText", this.inputText)
    //   try {
    //     const response = await openai.chat.completions.create(
    //       {
    //         model: 'gpt-3.5-turbo',
    //         messages: [
    //               {
    //                 role: 'user',
    //                 content: `Summarize: ${this.inputText}`,
    //               },
    //             ],
    //         temperature: 0.7,
    //         top_p: 1,
    //         frequency_penalty: 0,
    //         presence_penalty: 0,
    //         n: 1,
    //         max_tokens: 240,
    //       },
    //       {
    //         headers: {
    //           'Content-Type': 'application/json',
    //           'Authorization': `Bearer ${apiKey}`,
    //         },
    //       }
    //     );

    //     console.log(response.choices[0].message.content);

    //       //console.log("response", response.data.usage)
    //       // summary .text is to add the text to the missing part in the prompt
    //       // const summary = response.data.choices[0].text;

    //     // summrize .trim is to remove the extra spaces
    //     const summary = response.choices[0].message.content;
    //     this.summary = summary;
    //    // console.log('Summary:', summary);
    //     // Do something with the summary
    //   } catch (error) {
    //     console.error('Error:', error);
    //   }
    // },

    // async generateDescription() {
    //  // const text = 'Your text to summarize goes here';
    //  const apiKey = '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'
    //  const configuration = new Configuration({
    //     apiKey: apiKey,
    //   });
    //   const openai = new OpenAIApi(configuration);
    //   console.log("openai", openai)
    //   console.log("inputText", this.inputText)
    //   try {
    //     const response = await openai.createCompletion(
    //       {
    //         model: "text-davinci-003",
    //         prompt: `Extract keywords from this text: ${this.inputText}`,
    //         max_tokens: 60,
    //         temperature: 0,
    //       },
    //       {
    //         headers: {
    //           'Content-Type': 'application/json',
    //           'Authorization': `Bearer ${apiKey}`,
    //         },
    //       }
    //     );
    //       console.log("response", response.data)
    //       // summary .text is to add the text to the missing part in the prompt
    //       // const summary = response.data.choices[0].text;

    //     // summrize .trim is to remove the extra spaces
    //     const description = response.data.choices[0].text;
    //     console.log("description", description)
    //     this.description = description;
    //    // console.log('Summary:', summary);
    //     // Do something with the summary
    //   } catch (error) {
    //     console.error('Error:', error);
    //   }
    // },
    // async summarizeText() {
    //   try {
    //     const configuration = new Configuration({
    //       apiKey: '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',
    //     });
    //     const openai = new OpenAIApi(configuration);
    //     const response = await openai.createCompletion({
    //       model: 'text-davinci-003', // Replace with the desired OpenAI engine
    //       prompt: this.inputText,
    //       maxTokens: 100,
    //       temperature: 0.3
    //     });

    //     this.summary = response.choices[0].text.trim();
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    // https://qrcode.tec-it.com/API/QRCode?data=
    // https://chart.googleapis.com/chart?cht=qr&chs=
    buildUrl(){
      this.p = this.FRONTEND_URL + this.$route.path
      console.log(this.p)
      this.fullUrl = 'https://qrcode.tec-it.com/API/QRCode?data=' + encodeURIComponent(this.p)
    },

    createBuildUrl(sectionId){
      this.p2 = this.FRONTEND_URL + this.$route.path + '?section=' + sectionId
      console.log("CourseDetailsModule QR Code URL", this.p2)
      this.fullQRUrl = 'https://qrcode.tec-it.com/API/QRCode?data=' + encodeURIComponent(this.p2)
    },

    cardModal() {
        this.$buefy.modal.open({
            parent: this,
            component: ModalForm,
            hasModalCard: true,
            customClass: 'custom-class custom-class-2',
            trapFocus: true
        })
    },
    async cancle(e){
      //this.$router.go(-1);
      e.preventDefault()
      try{
          this.$router.push("/instructor-courses");
          location.reload(this.$router.currentRoute);
      }catch(error){
          this.error = true
      }     
    },
     async triggerEvent(value) {
      try{
      this.active = value;
      if(value){
      this.course.isPublic = true
      console.log("Public activated")
      }else{
        this.course.isPublic = false
        console.log("Public deativated")
      }
      }catch(err){
        this.error = true
      }
      
    },
    setIsUsersCourse() {
      try{
      console.log("setUsersCourse Method", this.usersCourses)
      this.userIsNotInCourse()
      console.log("SUPERKRÄFTE", this.superAdmin)
      if (this.usersCourses) {
        console.log(
          "course data available – figuring out if this course is users course"
        );
       // console.log("course id", this.course.id);
        
         const usersCourse = this.usersCourses.find((userCourse) => {
          return userCourse.id == this.course.id;
        });

       //const usersCourse = this.course.id;
       // console.log("users Course", usersCourse)
        this.isUsersCourse = usersCourse ? true : false;

        
        if (usersCourse && this.user.role.name == 2 || this.course.instructor.email === this.user.email || this.superAdmin){
          this.isInstructorsCourse = true;
          console.log("section length", this.course.sections.length)
          for(var i = 0, len = this.course.sections.length; i <= len; i++){
            console.log("module length", this.course.sections[i].modules.length)
            console.log("module", this.course.sections[i].modules)
            if(this.course.sections.length == 1){
              this.isOpenSection = i - 1
            }else{

              this.isOpenSection = i
            }
          }
       
        }
        else{
          this.isInstructorsCourse = false;
        } 

        // console.log("is Police course:", this.isPolizeiCourse);
        // console.log("is Feuerwehr course:", this.isFeuerwehrCourse);

        // console.log("is users course:", this.isUsersCourse);
        // console.log("user is instructor:", this.isInstructorsCourse);
        // console.log("modules", this.modules);
      }
      }catch(error){
        console.log("Error setIsUsersCourse CourseDetails", error)
      }
    },
    // activateEdit(id) {
    //   const elements = document.getElementById(id);

    //   console.log("activateEdit", elements);

    //   for (let i = 0; i < elements.length; i++) {
    //     const element = elements[i];
    //     element.editing = true;
    //   }
    // },

    activateSave() {
      //console.log("something changed")
      this.edited = true;
      Toast.open({
            message: `Änderung erfolgreich`,
            position: 'is-top',
            type: 'is-success is-light'
         })
    },
    async saveChanges(e) {
      e.preventDefault()
      try{
        this.countlicence()
        //console.log("updated course", this.course);
        Toast.open({
            message: `Der Kurs wurde erfolgreich geändert!`,
            duration: 8000,
            progressBar: true,
            position: 'is-top-center',
            type: 'is-success',
            pauseOnHover: true
         })
        this.$store.dispatch("update", this.course);
        this.$router.push({path: "/newcoursechoice"});
        //this.$router.go(-1);
      }catch(error){
        console.log("error saveChanges courseDetails",error)
      }
    },

    async checkChanges(e){
      e.preventDefault()
      try{
        this.countlicence()
      }catch(e){
        console.log(e)
      }
    },

    async triggerEventCC(value) {
      try{
      this.active = value;
      if(value){
      this.course.isInvite = true
      this.isActiveHint = true
      this.course.isInviteCourse = true
      console.log("CC activated")
      this.active = true
      }else{
        this.course.isInvite = false
        console.log("CC deativated")
        this.active = false
        this.course.isInviteCourse = false
      }
      }catch(err){
        this.error = true
      }
      
    },

    async triggerEventInvite(value) {
      try{
      this.active = value;
      if(value){
      this.course.isInviteCourse = true
      console.log("Invite activated")
      this.active = true
      }else{
        this.course.isInviteCourse = false
        console.log("Invite deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },

    async triggerEventProtect(value) {
      try{
      this.active = value;
      if(value){
      this.course.isProtected = true
      console.log("Protect activated")
      this.active = true
      }else{
        this.course.isProtected = false
        console.log("Protect deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },
    async triggerEventDraft(value) {
      try{
      this.active = value;
      if(value){
      this.course.isDraft = true
      console.log("Draft activated")
      this.active = true
      }else{
        this.course.isDraft = false
        console.log("Draft deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },

     noLicence(){
      this.course.noLicence = true
    }, 

    createSection() {
      this.edited = true;
      console.log("creating new section...");
      console.log("index", this.course.sections.length)
      this.course.sections.push({
        name: "Titel für Kapitel eingeben",
        description: "Beschreibung eingeben",
        index: this.course.sections.length,
        modules: [],
      });
      Toast.open({
            message: `Neues Kapitel für den Kurs erstellt!`,
            position: 'is-bottom',
            type: 'is-success is-light'
         })
         this.bottom = document.body.scrollHeight
          window.scrollTo(0, this.bottom);
    },
    // createModule(sectionIndex) {
    //   this.edited = true;
    //   console.log("creating new module...");

    //   this.course.sections[sectionIndex].modules.push({
    //     name: "New Module",
    //     description: "Description",
    //     index: this.course.sections[sectionIndex].modules.length,
    //   });
    // },

    deleteSection(sectionIndex){
      this.edited = true;
      console.log("Delete section...");
      console.log("sections", this.course.sections)
      console.log("current section", this.course.sections[sectionIndex])
      console.log("current section id", this.course.sections[sectionIndex].index)
      try{
          Toast.open({
          message: `Kapitel <b>` + this.course.sections[sectionIndex].name + `</b> wurde entfernt!`,
          position: 'is-bottom',
          type: 'is-warning is-light'
          })
          this.course.sections.splice(sectionIndex, 1)
          console.log("sections", this.course.sections)
          this.triggerEventCC(false)
                  //this.noLicence(false)
      }catch(e){
        console.log(e)
      }
    },


  countlicence(){
    this.edited = true;
    let response = this.course.sections
    console.log("res", response)
    
    var keyCountCourses = Object.keys(response).length
    console.log("keyCountCourses", keyCountCourses)
    var ObjectX = Object.keys(response)
    console.log("ObjectX", ObjectX)
    
    this.next = JSON.stringify(response)
    this.nextObject = response
    
    ObjectX.forEach((item, keyCountCourses) => {
        var ObjectModules = response[keyCountCourses].modules
        //var keyCountCourseModules = response[keyCountCourses].modules.length
        
    ObjectModules.forEach((item, index) => {
      //console.log(keyCountCourseModules)
            //console.log("userObj1 collection count", item)
            ObjectX.push({"id":keyCountCourses, "licence":this.nextObject[Object.keys(this.nextObject)[keyCountCourses]].modules[index].licence});
        })
        });
        //console.log("slice ObjectX", ObjectX.slice(keyCountCourses))
        this.JsonObjectA = ObjectX.slice(keyCountCourses)
        console.log("JsonObjectA",this.JsonObjectA)
        
        const data = JSON.stringify(this.JsonObjectA)

/*              const result = Object.keys(Object.assign({}, ...data))
        console.log(result)
        console.log(result.map(item => Object.keys(item)[0]));
        //const resultStr = JSON.stringify(result)
*/
        this.userObj1 = JSON.parse(data, (key, value) => {
          //console.log("value manifest object", key)
          if (value === false && this.user.role.name > 0){
            //console.log("licence position ist false", value)
            
              Toast.open({
                message: `Der Kurs enthält ein Modul ohne CC-Lizenz und wird somit automatisch zu einem Invite Kurs!`,
                duration: 4000,
                position: 'is-top',
                role: 'alert',
                type: 'is-danger is-light',
            })
            this.triggerEventCC(true)
            this.noLicence()

            //console.log("Tag Detail Collection", this.tag)
          }
          
/*               switch(key){
            case this.currentRepo:

              //console.log("-----> manifest Array", Object.values(this.manifestArray))
              //console.log(Object.values(this.manifestArray)[1])
              // Object.keys(obj)[0]
              break;
              default:
                
              } */
              return value
            })
              
    },

    modulesNotInSection(sectionIndex) {
      let modulesInSection = this.course.sections[sectionIndex].modules;
      let modulesNotInSection = [];

      console.log("modulesInCourse", JSON.stringify(modulesInSection))
      console.log("module length", this.modules.length)

      let inSection = false;
      for (let i = 0; i < this.modules.length; i++) {
        const mod = this.modules[i];
        inSection = false;

       
        if (!inSection || !mod.name) modulesNotInSection.push(mod);
      }

      return modulesNotInSection;
    },

    // Altes modulesNotInSection 
/*     modulesNotInSection(sectionIndex) {
      try{
      let modulesInSection = this.course.sections[sectionIndex].modules;
      let modulesNotInSection = [];

      let inSection = false;
      for (let i = 0; i < this.modules.length; i++) {
        const mod = this.modules[i];
        inSection = false;
       // console.log("mod licence", mod.licence)

        for (let j = 0; j < modulesInSection.length; j++) {
          const modInSection = modulesInSection[j];
          if (modInSection.name === mod.name) inSection = true;
        }
        if (!inSection) modulesNotInSection.push(mod);
      }
      return modulesNotInSection;
      }catch(error){
        console.log("Error modulesNotInSection CourseDetails", error)
      }
    }, */
    
    deleteModule(sectionIndex, modIndex){
      this.edited = true;
      try{
        var sectionId = 0
        var modId = 0
        let moduleDelete = []

        console.log("delete module...", modIndex);
        console.log("delete module in section", sectionIndex);
        console.log("course.sections", this.course.sections)
        
        for (let i = 0; i < this.course.sections.length; i++){
          const modSec = this.course.sections[i];
          const modSecArray = modSec.modules
          
          if(modSec.id === sectionIndex){
            sectionId = i
            //console.log("modSec", modSec)
          }

          for (let j = 0; j < modSecArray.length; j++){
            const secModules = modSecArray[j]
            //console.log("secModules", secModules)
            if(secModules.id == modIndex){
              //console.log("modIndex", modIndex)
              //console.log("secModules.id", secModules.id)
              modId = j
              //console.log("mod in section", secModules)
              //console.log("j",  j)
              //console.log("j",  modSec.modules[j])
              // console.log("section ID from loop", sectionId)
              // console.log("mod array ID from loop", modId)
              console.log("mod to delete", this.course.sections[sectionId].modules[modId])
              Toast.open({
              message: `Content <b>` + this.course.sections[sectionId].modules[modId].name + `</b> wurde entfernt!`,
              position: 'is-bottom',
              type: 'is-warning is-light'
              })
              this.course.sections[sectionId].modules.splice(modId,1)
              this.triggerEventCC(false)
            }
          }
        }
        
        return moduleDelete

        //this.triggerEventCC(false)
        
       //this.course.sections.splice(sec, 1)
    
        //this.course.sections[sectionIndex].modules.push(mod);
      }catch(e){
        console.log(e)
      }
    },

    addModule(sectionIndex) {
      this.edited = true;
      try{
        console.log("creating new module...");
        console.log("modules in section", this.course.sections[sectionIndex].modules.length);
        console.log("selectedOptions", this.selectedOptions)

        /* if we use b-field we need getElementByID  */
        // console.log("b-field getElementByID", document.getElementById("modules").value);
        // const modName = document.getElementById("modules").value;
        
        /* if we use b-dropdown we need getElementByID  */
        // console.log("moduleId", this.selectedOptions[0].id);
        //console.log("selectedOptions getElementByID", this.selectedOptions[0].name);
        const modName = this.selectedOptions.name;

        const modSectionName = this.course.sections[sectionIndex].name;
        // const modSectionId = this.course.sections[sectionIndex];
        
     /*    const mod = this.selectedOptions.find((mod) => {
          console.log("mod find", mod)
          //console.log("modId find", mod.id)
          //console.log("modIdentifier find", mod.identifier)
          //console.log("modName find", mod.name)
          //console.log("modName sections find", mod.sections.name)
  
          return mod.name == modName;
        }); */
        const mod = this.selectedOptions
        console.log("mod before licence", mod)
        console.log("mod licence", mod.licence)
  
         console.log("modSectionName", modSectionName)
        // console.log("modSection Id", JSON.stringify(modSectionId))
        // console.log("sectionIndex", sectionIndex)
  
        if (modSectionName){
          console.log("modSectionName", modSectionName)
          this.course.sections[sectionIndex].modules.push(mod);
          //console.log("mod push", this.course.sections[sectionIndex].modules.push(mod))
          console.log("sectionIndex", sectionIndex)
          console.log("modName", modName)
          console.log("modSectionName", modSectionName)
          
          Toast.open({
              message: `Das Modul <b>` + modName + `</b> wurde dem Kapitel <b>` + modSectionName + `</b> hinzugefügt`,
              position: 'is-bottom',
              duration: 8000,
              role: 'success',
              type: 'is-success is-light'
           })
  
        }else{
              Toast.open({
              message: `Es wurde kein Modul ausgewählt!`,
              position: 'is-bottom',
              duration: 8000,
              role: 'alert',
              type: 'is-danger is-light'
           })
        }
        //this.course.sections[sectionIndex].modules.push(mod);
      }catch(e){
        console.log(e)
      }
      
    },

/*     // Altes addModule
     addModule(sectionIndex) {
      this.edited = true;
      console.log("creating new module...");
      const modName = document.getElementById("modules").value;
      
      const mod = this.modules.find((mod) => {
        return mod.name == modName;
      });
      // console.log("mod Name", mod.name)
      // console.log("mod id", mod.id)
      // console.log("mod licence", mod.licence)

      if(mod.licence == false){
        Toast.open({
            message: `Dem Kurs wurde ein Modul ohne CC-Lizenz hinzugefügt`,
            duration: 8000,
            progressBar: true,
            position: 'is-top-left',
            role: 'alert',
            type: 'is-is-warning is-light',
            pauseOnHover: true
         })
      }else{
        console.log("Mod hat CC Lizenz")
      }
     // console.log("sectionIndex",sectionIndex)

      this.course.sections[sectionIndex].modules.push(mod);

/*       this.course.section = skill;
      console.log("nnew skill", this.course.skill.name); */
  // },  

    orderCourseCategories() {
      try{
      console.log("this.cour", this.courseCategories);
      if (this.course && this.courseCategories) {
        const category = this.courseCategories.find((category) => {
          return category.name === this.course.course_category.name;
        });
        console.log("cate", category);

        for (let i = 0; i < this.courseCategories.length; i++) {
          const category_i = this.courseCategories[i];
          if (category_i.name === category.name) {
            let temp = this.courseCategories[0];
            this.courseCategories[0] = category_i;

            for (let j = 1; j <= i; j++) {
              let temp2 = this.courseCategories[j];
              this.courseCategories[j] = temp;
              temp = temp2;
            }
          }
        }
      //  console.log("courseCat ordered", this.courseCategories);
      }
    }catch(error){
      console.log("Error orderCourseCategories CourseDetails")
    }
    },
    orderSkills() {
      try{
      if (this.course && this.skills) {
        const skill = this.skills.find((skill) => {
          return skill.name === this.course.skill.name;
        });
        console.log("skill", skill);

        for (let i = 0; i < this.skills.length; i++) {
          const skill_i = this.skills[i];
          if (skill_i.name === skill.name) {
            let temp = this.skills[0];
            this.skills[0] = skill_i;

            for (let j = 1; j <= i; j++) {
              let temp2 = this.skills[j];
              this.skills[j] = temp;
              temp = temp2;
            }
          }
        }
       // console.log("skills ordered", this.skills);
      }
    }catch(error){
      console.log("Error orderSkills CourseDetails")
    }
    },
    changeCategory() {
      try{
      this.edited = true;
      console.log("changing category...");
      const categoryName = document.getElementById("categories").value;
      const category = this.courseCategories.find((category) => {
        return category.name === categoryName;
      });
      console.log("category", category)
      this.course.course_category = category;
      console.log("nnew vategory", this.course);
      }catch(error){
        console.log("Error changeCategory CourseDetails")
      }
    },
    changeSkill() {
      try{
      this.edited = true;
      console.log("changing skill...");
      const skillName = document.getElementById("skills").value;
      const skill = this.skills.find((skill) => {
        return skill.name === skillName;
      });

      this.course.skill = skill;
      console.log("nnew skill", this.course.skill.name);
      }catch(error){
        console.log("Error changeSkill CourseDetails")
      }
    },
/*     addFile(sectionIndex, modIndex) {
       this.edited = true;
       console.log("adding file...");

       const id = sectionIndex + "." + modIndex;
       console.log("id", id);

      const fileSelector = document.getElementById(id);
      console.log("fileSelector", fileSelector);
       fileSelector.addEventListener("change", (event) => {
         const newFile = event.target.files[event.target.files.length - 1];
        console.log("newFile", newFile);

         this.course.sections[sectionIndex].modules[modIndex].media.push(
           newFile
         );
       });
     }, */
/*     activeTab(element) {
      if (element === "Videos") {
        this.tab = "Videos";
      } else if (element === "Slides") {
        this.tab = "Slides";
      } else if (element === "Audio") {
        this.tab = "Audio";
      }
    }, */
    userIsNotInCourse() {
        console.log("user_permissions_users", this.course.users_permissions_users.some((p) => p.email === this.user.email))
    if (this.course.users_permissions_users.some((p) => p.email === this.user.email)) {
        this.userInvited = true
        this.isActiveHint = false
        this.isActiveHintInvited = true
        console.log("user invited:", this.userInvited)
    }
    if(this.user.user_permissions.some((p) => p.key === "super_admin" )){
      console.log("Dieser User hat Super_admin Kräfte")
      this.superAdmin = true
    }
  },

  },
mounted(){
  this.userIsNotInCourse()

},
  beforeUpdate(){
    console.log("beforeMount isProtected CourseDetails", this.course.isProtected)
    if(!this.course.isInvite){
      this.course.noLicence = false
      this.isActiveHint = false
    }
    if(this.course.isProtected === true ){
      let user = localStorage.getItem('user')
      ? localStorage.getItem('user')
      : null;
      user = JSON.parse(user);
    
/* 
      console.log("Diese Seite ist nur für bestimmte Nuter und Geschützt", user)
      console.log("course courseProfession CourseDetails", this.course.courseProfession)
      console.log("course user_permissions CourseDetails", user.user_permissions.some((p) => p.key === user.rolle))
      console.log("es existiert keine Rolle und der Kurs ist geschützt für:", this.course.courseProfession)
      console.log("User Rolle courseDetails", user.rolle)
      console.log("Dieser Kurs gehört zur Gruppe:", this.course)
      console.log("instructor email", this.course.instructor.email)
      console.log("current user", user) */

      if(user === null)
      this.$router.push('/404')

      if(user.user_permissions.some((p) => p.key === "super_admin")){
        console.log("willkommen")
      }else if(this.course.instructor.email != user.email){
        // this.$router.push('/404')
      }else{
        console.log("Welcome")
      }

      if(user){
        console.log("user eingeloggt")
        console.log("user rolle", user.rolle)
        console.log("user role", user.user_permissions.some((p) => p.key === user.rolle))
        console.log("course Profession", this.course.courseProfession)
        if ((user.user_permissions.some((p) => p.key == user.rolle)) && user.rolle == this.course.courseProfession || this.superAdmin) {
          console.log("course courseProfession CourseDetails", this.course.courseProfession)
          console.log("course user_permissions CourseDetails", user.user_permissions.some((p) => p.key === user.rolle))
          this.protect = false
        }else{
          this.protect = true
        }
      }else{
        if(this.course){
          console.log("es existiert keine Rolle und der Kurs ist geschützt für:", this.course.courseProfession)
          this.protect = true
          // this.$router.push('/courses');
        }
      }
        if (!user && this.course.isProtected || user === null && this.course.isProtected)
        console.log("Dieser Kurs ist geschützt!")
      
    }
  },   
  computed: {
    ...mapState({
      courseCategories: "courseCategories",
      usersCourses: "usersCourses",
      JsonObjectA: "JsonObjectA"
    }),
    currentDate() {
      return Date.now();
    },
    didLoad: function () {
      // this is just a bool to load the data setting methods when page is called. ignore its value.
      console.log("loading page...");
      if (this.course === null){
        console.log("Kurs ist NULL")
        this.setCourseData();
      } 
      if (this.isUsersCourse === null){
        console.log("UserCourse ist Null")
        //this.userIsNotInCourse()
        this.setIsUsersCourse();
      } 
    //  console.log("course", this.course);
      return true;
    },
    classObject() {
    return {
      //active: this.noLicence,
      //active: this.course.isInvite,
      'inviteCourseDetected': this.noLicence,
    }
  }
  },
  apollo: {
    course: {
      query: gql`
        query ($id: ID!) {
          course(id: $id) {
            id
            name
            description
            duration
            isPublic
            isInvite
            isInviteCourse
            isProtected
            isDraft
            noLicence
            courseProfession
            users_permissions_users{
            id
            username
            email
            }
            course_category {
              id
              name
            }
            skill {
              id
              name
            }
            instructor {
                id
                firstName
                lastName
                email
                profession
              }
            sections {
              id
              name
              description
              modules {
                id
                name
                description
                licence
                iFrame_URL
                CC
                module_subcategory
                media {
                  id
                  name
                  mime
                  url
                }
              }
            }
            instructor {
              id
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id,
        };
      },
    },
    modules: {
      query: gql`
        query {
          modules {
            id
            identifier
            name
            description
            licence
            iFrame_URL
            CC
            sections {
              id
              name
            }
            media {
              id
              name
              mime
              url
            }
          }
        }
      `,
    },
    sectionsId: {
      query: gql`
              query {
					sections{
            id
            name
          }
        }
        `,
    },
    courseCategories: {
      query: gql`
        query {
          courseCategories {
            id
            name
          }
        }
      `,
    },
    skills: {
      query: gql`
        query {
          skills {
            id
            name
          }
        }
      `,
    },
    moduleCategories: {
      query: gql`
        query {
          moduleCategories {
            name
            modules {
              id
              name
              description
              licence
              iFrame_URL
              CC
              module_subcategory
              sections{
                id
              }
              media {
                name
                mime
                url
              }
            }
          }
        }
      `,
    },
  },
  watch: {
    dataToBeWatched: function(val){
      if(val){
        console.log("something chaged")
      }
    },
    course: function () {
      try{ 
        this.setIsUsersCourse();
        this.orderCourseCategories();
        this.orderSkills();
        this.addModule();
      }catch(e){
        console.log("error course function watch")
      }
    },
    usersCourses: function () {
      try{
        this.setIsUsersCourse();
      }catch(e){
        console.log("error usersCourses function watch", e)
      }
    },
    courseCategories: function () {
      try{
        this.orderCourseCategories();
      }catch(e){
        console.log("error courseCategories function watch",e)
      }
    },
    skills: function () {
      try{
        this.orderSkills();
      }catch(e){
        console.log("error skills function watch",e)
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
@import url("https://unpkg.com/buefy/dist/buefy.min.css");

#sidebar{
 width: 400px;
} 
  /* enter transitions */
  .toast-enter-active {
    animation: wobble 0.5s ease;
  }
  .sidebar{
    width: 400px
  }
  .sidebar-page {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    // min-height: 100vh;
    .sidebar-layout {
        display: flex;
        flex-direction: row;
        min-height: 100%;
        // min-height: 100vh;
    }
}
  /* leave transitions */
  .toast-leave-to {
    opacity: 0;
    transform: translateY(-60px);
  }
  .toast-leave-active {
    transition: all 0.3s ease;
  }

body {
  font-family: "Lato", sans-serif;
}
.toggle__protect_button input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    width: 1px;
    height: 1px;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
.image {
  height: 200px;
}
.video {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.video-width {
  width: 100%;
}
.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.panel {
    background-color: #ffffff;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
    position:fixed;
    right:0px;
    bottom:10px;
    width:60em;
    z-index:100;
}
.panel2 {
    position:fixed;
    right:0px;
    bottom:10px;
    width:6.5em;
    z-index:100;
}
.lockedCourse {
    background-color: rgba(0, 0, 0, 0.05);
    display:inline-block;
    border-radius:6px;
    background: #BFCBD9;
    box-shadow: inset 0 0 1px #BFCBD9;
    position:relative;
    margin-left: 20px;
    width: 100%;
    transition: all .25s;
}
.publicCourse {
    display:inline-block;
    //border-radius:6px;
    // background: #adedcb;
    // box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.inviteCourse {
    display:inline-block;
    border-radius:6px;
    // background: #3838fab6;
    //box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.inviteCourseDetected {
  background-color: rgba(0, 0, 0, 0);
  pointer-events: none !important;
}
.protectedCourse {
    display:inline-block;
    border-radius:6px;
    // background: #f42d97a8;
    box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.activeSection {
  border: 1px solid black;
  border-radius:6px;
}
.iconPanel{
  margin-left: 30px;
}
.vue-grid-layout {
    background: #eee;
}
.vue-grid-item:not(.vue-grid-placeholder) {
    background: #ccc;
    border: 1px solid black;
}
.vue-grid-item .resizing {
    opacity: 0.9;
}
.vue-grid-item .static {
    background: #cce;
}
.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}
.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}
.vue-grid-item .minMax {
    font-size: 12px;
}
.vue-grid-item .add {
    cursor: pointer;
}
.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}

.tag-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 10px; /* Adjust the gap value as needed */
}
.tag-item {
  margin: 2px;
}

@media (max-width: 700px) {
         .long {
             max-width: 100%;
             flex-basis: 100%;
         }
         .image {
             width: 100%;
             height: 100%;
         }
}

@media screen and (max-width: 1023px) {
  .b-sidebar {
        .sidebar-content {
            &.is-mini-mobile {
                &:not(.is-mini-expand),
                &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
                    .menu-list {
                        li {
                            a {
                                span:nth-child(2) {
                                    display: none;
                                }
                            }
                            ul {
                                padding-left: 0;
                                li {
                                    a {
                                        display: inline-block;
                                    }
                                }
                            }
                        }
                    }
                    .menu-label:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
@media screen and (min-width: 1024px) {
  .b-sidebar {
        .sidebar-content {
            &.is-mini {
                &:not(.is-mini-expand),
                &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
                    .menu-list {
                        li {
                            a {
                                span:nth-child(2) {
                                    display: none;
                                }
                            }
                            ul {
                                padding-left: 0;
                                li {
                                    a {
                                        display: inline-block;
                                    }
                                }
                            }
                        }
                    }
                    .menu-label:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}

/* a[href$=".pdf"] {
  background: url(/assets/images/PDF_file_icon.png) no-repeat left center;
  padding-left: 28px;
  border-bottom: none !important;
} */
</style>
